"use client";
import { Carousel } from "@/components/ui/Carousel";
import type { BlokContentCards } from "@/storyblok";
import { type BlokProps, StoryblokComponent } from "@frend-digital/storyblok";
import BlokWrap from "../BlokWrap";
import styles from "./ContentCardsBlok.module.css";
import { clsx } from "@frend-digital/ui";
import { SegmentControl } from "@/components/SegmentControl";

export const ContentCardsBlok = ({ blok, preview }: BlokProps<BlokContentCards>) => {
	const alignmentClass = blok.textAlignment === "center" ? styles.center : styles.left;
	return (
		<SegmentControl segments={blok}>
			<BlokWrap data-animate editable={blok} asChild>
				<div className={styles.content}>
					{blok.title && (
						<h2 data-fade className={styles.title}>
							{blok.title}
						</h2>
					)}
					<Carousel data-fade wrapperClassName="mobile">
						{blok.cards?.map((card) => (
							<StoryblokComponent key={card._uid} blok={card} preview={preview} />
						))}
					</Carousel>
					<div data-fade className={clsx("desktop", styles.inner)}>
						{blok.cards?.map((card) => (
							<div key={card._uid} className={styles.column}>
								<StoryblokComponent blok={card} preview={preview} className={alignmentClass} />
							</div>
						))}
					</div>
				</div>
			</BlokWrap>
		</SegmentControl>
	);
};
